import { render, staticRenderFns } from "./set-param.vue?vue&type=template&id=22a29593&scoped=true"
import script from "./set-param.vue?vue&type=script&lang=js"
export * from "./set-param.vue?vue&type=script&lang=js"
import style0 from "./set-param.vue?vue&type=style&index=0&id=22a29593&prod&lang=scss&scoped=true"
import style1 from "./set-param.vue?vue&type=style&index=1&id=22a29593&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a29593",
  null
  
)

export default component.exports